export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/infoCircleRed.aad3fee7.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};